import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import {
  ContainerItemModel,
  ContainerModel,
} from '@app/models/server/layout.model';
import { B2bPropertyCardComponent } from '@app/new-ui-lib/b2b-cards/components/b2b-property-card/b2b-property-card.component';
import { B2bDesktopPropertyCardComponent } from '@app/new-ui-lib/b2b-cards/components/b2b-desktop-property-card/b2b-desktop-property-card.component';
import { PromotionData, WidgetData } from '@app/models/server/promotion.model';
import { Params } from '@angular/router';
import { Observable } from 'rxjs';
import { FEATURE_TYPES } from '@app/constants/app-settings';
import { NgClass } from '@angular/common';

@Component({
  selector: 'lib-feature-list-item',
  templateUrl: './feature-list-item.component.html',
  styleUrls: ['./feature-list-item.component.scss'],
  standalone: true,
  imports: [B2bPropertyCardComponent, B2bDesktopPropertyCardComponent, NgClass],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FeatureListItemComponent implements OnInit, OnDestroy {
  @Input() compData: {
    container?: ContainerModel;
    containerItem?: ContainerItemModel;
    index?: number;
    promotionData?: PromotionData;
    queryParams: Params;
  };

  @Input() enableMapView: boolean;

  @Output() selectedPropertyEvent: EventEmitter<any> = new EventEmitter();

  // isDesktop: boolean = this.b2bDeviceUtilService?.isDesktop();

  selectedWidget: WidgetData;

  loadedEvent = this.onLoaded.bind(this);

  protected readonly F_TYPES = FEATURE_TYPES;

  promotionContainers$: Observable<ContainerModel[]>;

  constructor() {} // private b2bDeviceUtilService: B2bDeviceUtilService, // private httpClientService: HttpClientService,

  ngOnInit() {
    /*if (this.compData?.promotionData?.widgets?.length > 0) {
      const loadWidgetAfter: number =
        this.compData?.promotionData?.loadWidgetAfter > 0
          ? this.compData?.promotionData?.loadWidgetAfter
          : 4;
      const index: number = this.compData.index + 1;
      const remainder: number = index % loadWidgetAfter;
      if (remainder === 0) {
        const value: number = index / loadWidgetAfter - 1;
        if (this.compData?.promotionData?.widgets?.[value]) {
          this.selectedWidget = this.compData?.promotionData?.widgets?.[value];
          // this.showLoader = true;
          this.fetchPromotionData();
        }
      }
    }*/
  }

  /*fetchPromotionData() {
    this.promotionContainers$ = this.httpClientService
      .post(
        'fetch-promotion-data',
        {
          promotionData: this.compData?.promotionData,
          widgetData: this.selectedWidget,
          queryParams: this.compData?.queryParams,
        },
        {},
        true,
      )
      .pipe(
        tap((data: ContainerModel[]) => {
          // this.showLoader = false;
          if (!data || data?.length === 0) {
            if (this.isDesktop) {
              if (this.selectedWidget.desktopConfig) {
                this.selectedWidget.desktopConfig.height = '0px';
              } else {
                this.selectedWidget.desktopConfig = {
                  height: '0px',
                };
              }
            } else {
              if (this.selectedWidget.mobileConfig) {
                this.selectedWidget.mobileConfig.height = '0px';
              } else {
                this.selectedWidget.mobileConfig = {
                  height: '0px',
                };
              }
            }
          }
        }),
        catchError((errorResponse: HttpErrorResponse) => {
          // this.showLoader = false;
          return of([]);
        }),
      );
  }*/

  onLoaded(event) {}

  ionViewDidLeave() {
    this.destroy();
  }

  ngOnDestroy(): void {
    this.destroy();
  }

  destroy() {}
}
